import React, { useState, useRef, useEffect } from 'react';
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import './FAQ.css';

const faqs = [
    {
        id: 1,
        header: "برای دریافت اعتبار از فارابی باید تمام سهامم را به فارابی منتقل کنم؟",
        text: `خیر، اعتبار معاملاتی به 10 درصد از پرتفوی سهام شما تعلق می‌گیرد. برای دریافت اعتبار رایگان از فارابی، کافیست به میزان اعتبار مورد نیاز، تمام یا بخشی از پرتفوی خود را به فارابی منتقل کنید. برای مثال فرض کنید پرتفوی شما در یک کارگزاری شامل 4 سهم با ارزش هر کدام 250 میلیون تومان باشد. با تغییر کارگزار ناظر دو سهم به پرتفوی خود در فارابی با مجموع ارزش 500 میلیون تومان، می‌توانید به اندازه 10 درصد آن، یعنی 50 میلیون تومان، اعتبار رایگان دریافت کنید.`,
        active: true
    },
    {
        id: 2,
        header: "حداقل و حداکثر پرتفوی مورد نیاز برای انتقال به فارابی چقدر است؟",
        text: `کمترین مبلغ اعتبار قابل ارائه پنج میلیون تومان است؛ بنابراین حداقل ارزش پرتفوی استاندارد جهت دریافت اعتبار معاملاتی، باید 50 میلیون تومان باشد. همچنین حداکثر میزان اعتبار نیز یک میلیارد تومان در نظر گرفته شده است که جهت دریافت این مبلغ لازم است 10 میلیارد تومان از پرتفوی سهام‌تان را به حساب خود در فارابی منتقل کنید.`
    },
    {
        id: 3,
        header: "پرتفوی انتقالی به فارابی باید دارای چه ویژگی‌هایی باشد؟",
        text: `مطابق قوانین سازمان بورس و اوراق بهادار، دریافت اعتبار شرایط و ضوابط خاصی دارد. بر این اساس پرتفوی استاندارد جهت دریافت اعتبار باید متنوع بوده(تک سهم نباشد) و متشکل از سهام شرکت‌های بورسی و فرابورسی باشد.`
    }
];

const AccordionItem = (props) => {
    const contentEl = useRef(null);
    const { handleToggle, active, faq } = props;
    const { header, id, text } = faq;
    const [height, setHeight] = useState('0px');

    useEffect(() => {
        if (contentEl.current) {
            setHeight(active === id ? `${contentEl.current.scrollHeight + 10}px` : '0px');
        }
    }, [active, id]);

    return (
        <div className="rc-accordion-card">
            <div className="">
                <div className={`p-3 ${active === id ? 'active' : ''}`} onClick={() => handleToggle(id)}>
                    <h5 className="rc-accordion-title">
                        <span>{active === id ? <FaAngleUp className="vertical-center" /> : <FaAngleDown className=" vertical-center" />} {header}</span>
                    </h5>
                </div>
            </div>
            <div ref={contentEl} className={`rc-collapse ${active === id ? 'show' : ''}`} style={{ height }}>
                <div className="rc-accordion-body">
                    <p className='mb-0'>{text}</p>
                </div>
            </div>
        </div>
    );
};

const FAQ = () => {
    const [active, setActive] = useState(1);

    const handleToggle = (index) => {
        setActive(active === index ? null : index);
    };

    return (
        <div className="faq-dropdown" style={{ padding: '50px' }}>
            <div className="card-body">
                <h2 className="faq-title text-center">سوالات متداول</h2>
                {faqs.map((faq) => (
                    <AccordionItem key={faq.id} active={active} handleToggle={handleToggle} faq={faq} />
                ))}
            </div>
        </div>
    );
};

export default FAQ;
